import { Routes, Route } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { Overview } from "@/pages/Overview";
import { LeadSummary } from "@/pages/LeadSummary";
import { NearbyCampaignsSummary } from "@/pages/NearbyCampaignsSummary";
import { GoalTracking } from "@/pages/GoalTracking";
import { ChannelEfficiency } from "@/pages/ChannelEfficiency";
import { MetaCampaigns } from "@/pages/MetaCampaigns";
import { LinkedInCampaigns } from "@/pages/LinkedInCampaigns";
import { GoogleAds } from "@/pages/GoogleAds";
import { UnidentifiedLeads } from "@/pages/UnidentifiedLeads";
import { Comparison } from "@/pages/Comparison";
import { Login } from "@/pages/Login";
import { OpenAIAds } from "@/pages/OpenAIAds";
import { WebstoreAnalyticsOverview } from "@/features/webstore-analytics/pages/WebstoreAnalyticsOverview";

import { AiWebsiteBuilderLeads } from "@/pages/AiWebsiteBuilderLeads";
import { MarketingUpdates } from "@/pages/MarketingUpdates";

export default function App() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="leads" element={<LeadSummary />} />
        <Route path="nearby-campaigns" element={<NearbyCampaignsSummary />} />
        <Route path="ai-website-builder" element={<AiWebsiteBuilderLeads />} />
        <Route path="goals" element={<GoalTracking />} />
        <Route path="efficiency" element={<ChannelEfficiency />} />
        <Route path="meta" element={<MetaCampaigns />} />
        <Route path="linkedin-ads" element={<LinkedInCampaigns />} />
        <Route path="google-ads" element={<GoogleAds />} />
        <Route path="openai-ads" element={<OpenAIAds />} />
        <Route path="unidentified" element={<UnidentifiedLeads />} />
        <Route path="comparison" element={<Comparison />} />
        <Route path="webstore-analytics" element={<WebstoreAnalyticsOverview />} />
        <Route path="marketing-updates" element={<MarketingUpdates />} />
      </Route>
    </Routes>
  );
}
